import { setCookie, getCookie } from './cookies';

export function themeAutodetect() {
  const initialTheme: string | null = getCookie('theme');
  if (!initialTheme) {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      setCookie('theme', 'dark', 7);
    }
    else {
      setCookie('theme', 'light', 7);
    }
  }

  const isSafari = navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0;
  const isEdge = navigator.appVersion.indexOf('Edge') > -1;
  if (!isSafari && !isEdge) {
    watchThemeChange();
  }
}

function watchThemeChange() {
  const themeToggleButton: HTMLElement | null = document.querySelector('#themeToggleButton');
  const body: HTMLElement | null = document.querySelector('body');

  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
    const newColorScheme = e.matches ? 'dark' : 'light';
    setCookie('theme', newColorScheme, 7);

    if (themeToggleButton != null && body != null) {
      if (newColorScheme === 'dark') {
        body.classList.add('dark-theme');
        themeToggleButton.classList.add('active');
      }
      else {
        body.classList.remove('dark-theme');
        themeToggleButton.classList.remove('active');
      }
    }
  });
}
